import React from "react";
import { Route, Routes } from 'react-router-dom'
import Login from '../pages/system/login/Login'
import Home from '../pages/system/home/Home'
import Ranking from "../pages/reports/ranking/Ranking";
import NewEvent from "../pages/operator/new-event/NewEvent";



const AdminRoute = (props) => {
    return (
        <Routes>
            <Route
                exact
                path={'/'}
                element={<Home />}
            />
            <Route
                exact
                path="/login"
                element={<Login />}
            />
            <Route
                exact
                path="/report/award"
                element={<Ranking token={props.token} bodyNotify={props.bodyNotify} path={{ get: 'award', export: 'award/export' }} pageTitle='Premiação Motoristas' validateToken={props.validateToken}/>}
            />
             <Route
                exact
                path="/admin/edit-event"
                element={<NewEvent token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
        </Routes>
    )
}


export default AdminRoute